/**
 * 地区树：接口可能含第四级「街道」，级联仅需要省/市/区，去掉街道子节点。
 * 规则：若子节点 code 字符串长度 > 6，视为街道级，不再展开。
 */
export function stripStreetLevel (nodes) {
  if (!Array.isArray(nodes) || !nodes.length) return []
  return nodes.map((node) => {
    const out = { code: node.code, name: node.name }
    const children = node.children
    if (!children || !children.length) return out
    const first = children[0]
    if (first && String(first.code).length > 6) {
      return out
    }
    out.children = stripStreetLevel(children)
    return out
  })
}

/**
 * 解析接口返回的 data（可能是数组或包在 data 里）
 */
export function unwrapRegionTree (res) {
  if (!res || res.code == null) return []
  const d = res.data
  if (Array.isArray(d)) return d
  if (d && Array.isArray(d.data)) return d.data
  if (d && Array.isArray(d.list)) return d.list
  return []
}
